import { Organisation } from '@/features'
import { Page } from '@/components'
import { variantProvider } from '@/app'
import { useMediaQueryDown } from '@/utils'
import { OrgDesktopPage, OrgMobilePage } from './components'

export type OrgPageProps = {
  organisation: Organisation.T.Organisation
}

export function OrgPage({ organisation }: OrgPageProps) {
  return (
    <Page
      pageTitle={organisation?.name || 'Organisation'}
      showSubHeader
      showFooter={false}
      subHeader={<Organisation.MyOrganisationSubHeader organisation={organisation} />}
      variants={['content:page', 'page:organisation']}
      styles={{
        innerWrapper: styles.innerWrapper
      }}
    >
      <RenderContent organisation={organisation} />
    </Page>
  )
}

const RenderContent = (props: OrgPageProps) => {
  const isLargeish = useMediaQueryDown('mid')
  return isLargeish ? <OrgMobilePage {...props} /> : <OrgDesktopPage {...props} />
}

const styles = variantProvider.createComponentStyle(
  theme => ({
    wrapper: {
      display: 'flex',
      flex: 1,

      gap: theme.spacing.value(5),
      ...theme.presets.fullWidth
    },
    innerWrapper: {
      [theme.media.down('small')]: {
        paddingTop: 0
      }
    },
    leftWrapper: {
      [theme.media.up('mid')]: {
        position: 'sticky',
        top: theme.spacing.value(2),
        left: 0,
        zIndex: 1,
        alignSelf: 'flex-start',
        width: '41%'
      }
    },
    rightWrapper: {
      flex: 1.5
    },
    stickyAside: {
      // position: 'sticky',
      // top: theme.values.headerHeight + theme.spacing.value(2),
      // overflowY: 'auto',
      // maxHeight: `calc( 100vh - ${theme.values.headerHeight + theme.spacing.value(4)}px)`,
      // overflowX: 'hidden',
      //   'scrollbar-width': 'none',
      // '&::-webkit-scrollbar': {
      //   display: 'none',
      // },
    }
  }),
  true
)
